// extracted by mini-css-extract-plugin
module.exports = {"body":"_105329b597--body--mfMHL","body--phone":"_105329b597--body--phone--eQ8X9","body--modal":"_105329b597--body--modal--XQEJu","error":"_105329b597--error--aejHK"};